import React from 'react';
import { useMainPerformanceCustomerSatisfaction } from '../../../hooks/useMainPerformanceKPIs';
import KPICard from '../../ui/KPICard';
import LoadingSpinner from '../../ui/LoadingSpinner';
import ErrorMessage from '../../ui/ErrorMessage';
import { KPIProps } from '../../../types/kpi';

const CustomerSatisfactionKPI: React.FC<KPIProps> = ({
  branchId = 0,
  timeRange = 'last6Months',
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const { data, isLoading, isError, error, refetch } = useMainPerformanceCustomerSatisfaction(branchId, timeRange);

  // Handle error callback
  React.useEffect(() => {
    if (isError && error && onError) {
      onError(error as Error);
    }
  }, [isError, error, onError]);

  // Helper function to format percentage values
  const formatPercentage = (value: number | string): string => {
    if (typeof value === 'string') return value;
    if (!value && value !== 0) return '0';
    return `${value != null ? value.toFixed(2) : '0'}%`;
  };

  if (isLoading && showLoading) {
    return (
      <div className={`animate-enter animate-delay-1 ${className}`}>
        <div className="card-base card-padding">
          <div className="flex items-center justify-center h-32">
            <LoadingSpinner variant="minimal" size="md" />
          </div>
        </div>
      </div>
    );
  }

  if (isError && error) {
    return (
      <ErrorMessage 
        message="خطا در دریافت اطلاعات رضایت مشتریان"
        onRetry={() => refetch()}
        className={className}
      />
    );
  }

  const kpiData = data || {
    customerSatisfaction: 0,
    avgParticipationRate: 0
  };

  return (
    <KPICard
      title="رضایت مشتریان"
      value={formatPercentage(kpiData.customerSatisfaction)}
      subtitle={`نرخ مشارکت: ${formatPercentage(kpiData.avgParticipationRate != null ? kpiData.avgParticipationRate.toFixed(2) : 0)}`}
      variant="success"
      accentStyle="corner"
      className={`animate-enter-up stagger-1 ${className}`}
      loading={isLoading && !showLoading}
    />
  );
};

export default CustomerSatisfactionKPI;